import { Stack } from "@mui/material";
import { DateTime } from "luxon";
import { SBCard, SBTypography, SBBox } from "modules/Commons";
import { useTranslation } from "react-i18next";
import { TooltipProps } from "recharts";
import {
	ValueType,
	NameType,
} from "recharts/types/component/DefaultTooltipContent";
import { useSystemTheme } from "themes/base";
import SBForecastInfoTooltip from "./SBForecastInfoTooltip";

export default (props: TooltipProps<ValueType, NameType>) => {
	const { t } = useTranslation();
	const { palette } = useSystemTheme();
	const chartData = (props.payload as any)[0]?.payload;

	if (!chartData) return <></>;

	const label = {
		value: DateTime.fromFormat(chartData?.date, "yyyy-MM-dd").toFormat(
			t("dateFormat")
		),
	};
	const real = { value: chartData?.real as number };
	const forecast = {
		min: chartData?.range[0] as number,
		max: chartData?.range[1] as number,
		value: chartData?.forecast as number,
	};
	const benchmark = {
		min: chartData?.rangeBenchmark[0] as number,
		max: chartData?.rangeBenchmark[1] as number,
		value: chartData?.forecastBenchmark as number,
	};

	return (
		<SBCard >
			<Stack p={1} px={2}>
				<SBTypography fontWeight="bold" variant="body2">
					{label?.value}
				</SBTypography>

				<SBBox display="flex" alignItems="center" mt={0.5}>
					<div
						style={{
							height: 3,
							width: 15,
							background: palette.real.main,
							content: "",
						}}
					/>
					<SBTypography ml={1} mr={2}>
						{t("real")}
					</SBTypography>
					<SBTypography ml="auto">
						{real?.value?.systemFormat({
							maximumFractionDigits: 0,
							minimumFractionDigits: 0,
						})}
					</SBTypography>
				</SBBox>
				<SBForecastInfoTooltip
					lineColor={palette.projected.main}
					lineBackground={palette.lightPurple.main}
					title={chartData?.primaryLabel || "forecast"}
					value={forecast?.value}
					min={forecast?.min}
					max={forecast?.max}
				/>
				<SBForecastInfoTooltip
					lineColor={palette.warning.main}
					lineBackground={`${palette.warning.main}22`}
					title={chartData?.benchmarkLabel || "benchmark"}
					value={benchmark?.value}
					min={benchmark?.min}
					max={benchmark?.max}
				/>
			</Stack>
		</SBCard>
	);
};
